import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-our-apps',
  standalone: true,
  imports: [],
  templateUrl: './our-apps.component.html',
  styleUrl: './our-apps.component.scss'
})
export class OurAppsComponent {
  constructor(
    private router:Router
  ){}

  
  goTo(link:any){
    this.router.navigate([link])
  }
}
